import React, { createElement } from "react";
import { QuiIcon } from "../_primitives/QuiIcon/QuiIcon.js";
export function WithIcon({ iconLeft, iconRight, iconSize, children }) {
    const maybeIconLeft = getIconElement(iconLeft, iconSize);
    const maybeIconRight = getIconElement(iconRight, iconSize);
    return createElement(React.Fragment, {}, maybeIconLeft, children, maybeIconRight);
}
function getIconElement(iconProp, size) {
    if (iconProp instanceof Function) {
        return iconProp();
    }
    if (iconProp) {
        return React.createElement(QuiIcon, { size: size, icon: iconProp, className: "qui-no-shrink" });
    }
    return null;
}
export function fieldSizeToIconSize(size) {
    if (size === "xs")
        return "sm";
    return size === "lg" || size === "xl" ? "lg" : "md";
}
